'use client'

import { SessionTable } from '@excellent/ui/blocks/lens/sessions/session-table'
import { useSnapshot } from '@lens/lib/use-snapshot'
import { PageHeader, Skeleton } from "@excellent/ui"

export default function SessionsPage() {
 const { snapshot, error, isLoading } = useSnapshot()
 const sessions = snapshot?.sessions
 const scopedProject = snapshot?.scopedProject ?? null

 return (
 <div className="flex flex-col">
 <div className="space-y-4">
 <PageHeader
 description={sessions ? `${sessions.length.toLocaleString()} sessions` : undefined}
 />
 {error && (
 <p className="text-destructive type-body ">Error: {String(error)}</p>
 )}
 {isLoading && !sessions && (
 <div className="space-y-2">
 {Array.from({ length: 8 }).map((_, i) => (
 <Skeleton key={i} className="h-10 rounded" />
 ))}
 </div>
 )}
 {sessions && <SessionTable sessions={sessions} scopedProject={scopedProject} />}
 </div>
 </div>
 )
}
